<div class="autocomplete__container">
  <input
    class="autocomplete__input"
    mmInput
    type="text"
    [id]="id"
    [placeholder]="placeholder"
    [matAutocomplete]="auto"
    (input)="onChangeValue($event)"
    (focus)="handleFocus()"
    [matAutocompletePosition]="'below'"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="onOptionClick($event.option.value)"
    class="autocomplete__dropdown"
  >
    <mat-option
      *ngFor="let result of results$ | async"
      (mousedown)="$event.preventDefault()"
      class="autocomplete__option"
      [value]="result"
    >
      <div
        *ngIf="!!getItemPrefixUrl"
        class="autocomplete__option__prefix"
        [ngStyle]="{ 'background-image': 'url(' + getItemPrefixUrl() + ')' }"
      ></div>

      {{ result.label }}
    </mat-option>
  </mat-autocomplete>
</div>
